import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Web\Studio\EntitlementController::index
* @see Http/Controllers/Web/Studio/EntitlementController.php:26
* @route '/studio/{team}/scenarios/{scenario}/entitlements'
*/
export const index = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/studio/{team}/scenarios/{scenario}/entitlements',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Web\Studio\EntitlementController::index
* @see Http/Controllers/Web/Studio/EntitlementController.php:26
* @route '/studio/{team}/scenarios/{scenario}/entitlements'
*/
index.url = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            team: args[0],
            scenario: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        team: typeof args.team === 'object'
        ? args.team.slug
        : args.team,
        scenario: typeof args.scenario === 'object'
        ? args.scenario.id
        : args.scenario,
    }

    return index.definition.url
            .replace('{team}', parsedArgs.team.toString())
            .replace('{scenario}', parsedArgs.scenario.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\Studio\EntitlementController::index
* @see Http/Controllers/Web/Studio/EntitlementController.php:26
* @route '/studio/{team}/scenarios/{scenario}/entitlements'
*/
index.get = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\EntitlementController::index
* @see Http/Controllers/Web/Studio/EntitlementController.php:26
* @route '/studio/{team}/scenarios/{scenario}/entitlements'
*/
index.head = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Web\Studio\EntitlementController::index
* @see Http/Controllers/Web/Studio/EntitlementController.php:26
* @route '/studio/{team}/scenarios/{scenario}/entitlements'
*/
const indexForm = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\EntitlementController::index
* @see Http/Controllers/Web/Studio/EntitlementController.php:26
* @route '/studio/{team}/scenarios/{scenario}/entitlements'
*/
indexForm.get = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\EntitlementController::index
* @see Http/Controllers/Web/Studio/EntitlementController.php:26
* @route '/studio/{team}/scenarios/{scenario}/entitlements'
*/
indexForm.head = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Web\Studio\EntitlementController::create
* @see Http/Controllers/Web/Studio/EntitlementController.php:53
* @route '/studio/{team}/scenarios/{scenario}/entitlements/create'
*/
export const create = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(args, options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/studio/{team}/scenarios/{scenario}/entitlements/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Web\Studio\EntitlementController::create
* @see Http/Controllers/Web/Studio/EntitlementController.php:53
* @route '/studio/{team}/scenarios/{scenario}/entitlements/create'
*/
create.url = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            team: args[0],
            scenario: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        team: typeof args.team === 'object'
        ? args.team.slug
        : args.team,
        scenario: typeof args.scenario === 'object'
        ? args.scenario.id
        : args.scenario,
    }

    return create.definition.url
            .replace('{team}', parsedArgs.team.toString())
            .replace('{scenario}', parsedArgs.scenario.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\Studio\EntitlementController::create
* @see Http/Controllers/Web/Studio/EntitlementController.php:53
* @route '/studio/{team}/scenarios/{scenario}/entitlements/create'
*/
create.get = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\EntitlementController::create
* @see Http/Controllers/Web/Studio/EntitlementController.php:53
* @route '/studio/{team}/scenarios/{scenario}/entitlements/create'
*/
create.head = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Web\Studio\EntitlementController::create
* @see Http/Controllers/Web/Studio/EntitlementController.php:53
* @route '/studio/{team}/scenarios/{scenario}/entitlements/create'
*/
const createForm = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\EntitlementController::create
* @see Http/Controllers/Web/Studio/EntitlementController.php:53
* @route '/studio/{team}/scenarios/{scenario}/entitlements/create'
*/
createForm.get = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\EntitlementController::create
* @see Http/Controllers/Web/Studio/EntitlementController.php:53
* @route '/studio/{team}/scenarios/{scenario}/entitlements/create'
*/
createForm.head = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Web\Studio\EntitlementController::store
* @see Http/Controllers/Web/Studio/EntitlementController.php:64
* @route '/studio/{team}/scenarios/{scenario}/entitlements'
*/
export const store = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/studio/{team}/scenarios/{scenario}/entitlements',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Web\Studio\EntitlementController::store
* @see Http/Controllers/Web/Studio/EntitlementController.php:64
* @route '/studio/{team}/scenarios/{scenario}/entitlements'
*/
store.url = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            team: args[0],
            scenario: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        team: typeof args.team === 'object'
        ? args.team.slug
        : args.team,
        scenario: typeof args.scenario === 'object'
        ? args.scenario.id
        : args.scenario,
    }

    return store.definition.url
            .replace('{team}', parsedArgs.team.toString())
            .replace('{scenario}', parsedArgs.scenario.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\Studio\EntitlementController::store
* @see Http/Controllers/Web/Studio/EntitlementController.php:64
* @route '/studio/{team}/scenarios/{scenario}/entitlements'
*/
store.post = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\Studio\EntitlementController::store
* @see Http/Controllers/Web/Studio/EntitlementController.php:64
* @route '/studio/{team}/scenarios/{scenario}/entitlements'
*/
const storeForm = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\Studio\EntitlementController::store
* @see Http/Controllers/Web/Studio/EntitlementController.php:64
* @route '/studio/{team}/scenarios/{scenario}/entitlements'
*/
storeForm.post = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Web\Studio\EntitlementController::destroy
* @see Http/Controllers/Web/Studio/EntitlementController.php:90
* @route '/studio/{team}/scenarios/{scenario}/entitlements/{entitlement}'
*/
export const destroy = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, entitlement: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, entitlement: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/studio/{team}/scenarios/{scenario}/entitlements/{entitlement}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Web\Studio\EntitlementController::destroy
* @see Http/Controllers/Web/Studio/EntitlementController.php:90
* @route '/studio/{team}/scenarios/{scenario}/entitlements/{entitlement}'
*/
destroy.url = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, entitlement: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, entitlement: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            team: args[0],
            scenario: args[1],
            entitlement: args[2],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        team: typeof args.team === 'object'
        ? args.team.slug
        : args.team,
        scenario: typeof args.scenario === 'object'
        ? args.scenario.id
        : args.scenario,
        entitlement: typeof args.entitlement === 'object'
        ? args.entitlement.id
        : args.entitlement,
    }

    return destroy.definition.url
            .replace('{team}', parsedArgs.team.toString())
            .replace('{scenario}', parsedArgs.scenario.toString())
            .replace('{entitlement}', parsedArgs.entitlement.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\Studio\EntitlementController::destroy
* @see Http/Controllers/Web/Studio/EntitlementController.php:90
* @route '/studio/{team}/scenarios/{scenario}/entitlements/{entitlement}'
*/
destroy.delete = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, entitlement: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, entitlement: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Web\Studio\EntitlementController::destroy
* @see Http/Controllers/Web/Studio/EntitlementController.php:90
* @route '/studio/{team}/scenarios/{scenario}/entitlements/{entitlement}'
*/
const destroyForm = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, entitlement: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, entitlement: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\Studio\EntitlementController::destroy
* @see Http/Controllers/Web/Studio/EntitlementController.php:90
* @route '/studio/{team}/scenarios/{scenario}/entitlements/{entitlement}'
*/
destroyForm.delete = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, entitlement: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, entitlement: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const entitlements = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    destroy: Object.assign(destroy, destroy),
}

export default entitlements